export default __webpack_public_path__ + "static/media/a9.b872a2e2.png";